import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store";
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";

interface ModeloModuloInputProps {
  errorState: string[];
  formState: FormProjetoHibridoType;
  onChangeValue: (formState: Partial<FormProjetoHibridoType>) => void;
}

export const ModeloModuloInput = ({ errorState, formState, onChangeValue }: ModeloModuloInputProps) => {
  const projetosHibridoStoreValidationsState = useProjetosHibridoStore(store => store.state.validations)
  const projetosHibridoStoreLoadingsState = useProjetosHibridoStore(store => store.state.loadings)
  const projetosHibridoStoreActions = useProjetosHibridoStore(store => store.actions)

  return (
    <InputComboBoxList
      id={"hibrido-modelo-modulo-field"}
      key={`hibrido-modelo-modulo-field`}
      label={"* Modelo do módulo"}
      textField="nome"
      valueField="componente_id"
      options={formState.modulos}
      disabled={!formState.modulos.length || projetosHibridoStoreLoadingsState.listagemModulos}
      disableClearable
      value={formState?.modulo_selecionado || null}
      helperText={projetosHibridoStoreValidationsState.modulo.helper}
      error={!projetosHibridoStoreValidationsState.modulo.status || errorState.includes("modulo_hibrido")}
      renderOptions={(option: any) => {
        return `${option?.nome}`
      }}
      renderOptionsLabel={(option: any) => {
          return `${option?.nome}`
        }}
      onChange={async (value) => {
        projetosHibridoStoreActions.changeValidationsValue({ modulo: { helper: '', status: true }})
        onChangeValue({ alterou_modulo: true, modulo_selecionado: value })
      }}
    />
  )
}